import React, { useState, useEffect } from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { useTranslation, Trans } from "react-i18next";
import { useCookies } from "react-cookie";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import { InputAdornment } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Resizer from "react-image-file-resizer";
import LinearProgress from '@material-ui/core/LinearProgress';
import ImageCrop from "../ImageCrop";
import ReactCrop from 'react-image-crop';

import { format } from "date-fns";

import { makeStyles } from "@material-ui/core";
import apiHelper from "../../utils/apiHelper";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function CropDemo({ src }) {
  const [crop, setCrop] = useState({ aspect: 16 / 9 })
  return <ReactCrop src={src} crop={crop} onChange={newCrop => setCrop(newCrop)} />
}

const schema = yup.object().shape({
  firstName: yup.string().required('firstName.mandatoryerror'),
  lastName: yup.string().required('lastName.mandatoryerror'),
  address: yup.string().required('address.mandatoryerror'),
  contactNumber: yup.string().required('contactNumber.mandatoryerror'),
  email: yup.string().email('email.formaterror').required('email.mandatoryerror'),
  dob: yup.string().required('dob.mandatoryerror'),
});

const useStylesAll = makeStyles((theme) => ({
  pageContainer: {
    display: "flex",
    justifyContent: "center",
  },
  container: {
    fontFamily: "Poppins",
    width: "100%",
    color: "#000000",
    padding: "10px 15px",
    [theme.breakpoints.up("md")]: {
      width: "85%",
      maxWidth: 1140,
      padding: "30px",
    },
    marginTop: "50px",
  },
  btn: {
    marginTop: "30px",
    [theme.breakpoints.up("md")]: {
      marginTop: "40px",
    },
  },
  wrapper: {
    position: 'relative',
    height: "94px",
  },
  highlight: {
    color: "#962013",
    textDecoration: "none",
  },
  forget: {
    color: "rgba(153, 153, 153, 0.5)",
    textDecoration: "none",
    position: "absolute",
    right: 0,
    top: "-3px",
    fontSize: "14px",
    "&:hover": {
      color: "rgba(153, 153, 153, 0.8)",
    },
  },
  propic: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    "&:hover": {
      cursor: "pointer",
    },
  },
  iconBtn: {
    backgroundColor: "unset",
    boxShadow: "none",
    color: "#727272",
    padding: 0,
    paddingRight: "20px",
    marginBottom: "0px",
    "&:hover": {
      color: "unset",
      backgroundColor: "unset",
      boxShadow: "none",
    },
  },
}));


const defaultProfile = {
  firstName: "",
  lastName: "",
  gender: "",
  address: "",
  contactNumber: "",
  email: "",
  dob: null,
  plan: {
    id: "",
    name: "",
    price: "",
  },
  iconImage: "",
  currentPassword: "",
  password: "",
  repassword: ""
};

function ProfileEditPage(props) {
  const { t, i18n } = useTranslation("profile");
  const classes = useStylesAll();
  const [cookies, setCookie] = useCookies();
  const [profile, setProfile] = React.useState(defaultProfile);
  const [icon, setIcon] = React.useState();
  const [iconName, setIconName] = React.useState("");
  const changeIcon = React.useRef(null);
  const [canUpdateDob, setCanUpdateDob] = React.useState(false);
  const [open, setOpen] = React.useState(false); //snackbar
  const [loading, setLoading] = React.useState(false);
  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        800,
        456,
        "JPEG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "file"
      );
    });
  
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: React.useMemo(() => defaultProfile, [defaultProfile]),
    resolver: yupResolver(schema),
  });

  function fetchData() {
    if (cookies.token) {
      try {
        apiHelper
          .getMemberProfile(cookies.token)
          .then(function (response) {
            response.data.gender = "" + response.data.gender;
            if (response.data.dob == "" || response.data.dob == null) {
              response.data.dob = null
              setCanUpdateDob(true);
            }
            setProfile({
              ...profile, 
              ...response.data
            });
          })
          .catch(function (error) {
            console.log("member profile error");
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    }
  }

  useEffect(() => {
    if (profile) {
      reset(profile)
    }
      
  },[profile])

  useEffect(() => {
    fetchData();
  }, [cookies.token]);

  function validatePassword(password) {
    const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/;
    return re.test(String(password));
  }

  const toSubmitProfileUpdate = (data) => {
    setLoading(true);
    clearErrors();
    var err = 0;
    var isUpdatePassword = !((typeof data.password == "undefined" || data.password == "") && (typeof data.repassword == "undefined" || data.repassword == "") && (typeof data.currentPassword == "undefined" || data.currentPassword == ""));
    if(isUpdatePassword){
      if (!data.password || !data.repassword || !data.currentPassword){
        if(!data.repassword){
          setError("repassword", {
            type: "manual",
            message: "repassword.mandatoryerror",
          });
        }
        
        if(!data.password){
          setError("password", {
            type: "manual",
            message: "password.mandatoryerror",
          });
        }
        
        if (!data.currentPassword){
          setError("currentPassword", {
            type: "manual",
            message: "currentPassword.mandatoryerror",
          });
        }
        if(!data.password && !data.repassword){
          setError("password", {
            type: "manual",
            message: "",
          });
          setError("repassword", {
            type: "manual",
            message: "repassword.mandatoryerror",
          });
        }
        err++;
      }
      
      if (data.password != data.repassword) {
        setError("repassword", {
          type: "manual",
          message: "repassword.mismatcherror",
        });
        err++;
      } else if (!validatePassword(data.password)) {
        setError("repassword", {
          type: "manual",
          message: "repassword.formaterror",
        });
        err++;
      }
    }
    
    if(!err){
      data.dob = format(new Date(data.dob), "yyyy-MM-dd");
      try {
          // update profile
          let json = {
            address: data.address,
            contactNumber: data.contactNumber,
            dob: data.dob,
            email: data.email,
            firstName: data.firstName,
            gender: data.gender,
            lastName: data.lastName,
          };
          if(isUpdatePassword){
            json.newPassword = data.password;
            json.oldPassword = data.currentPassword;
          }
          apiHelper
            .updateMemberProfile(cookies.token, json)
            .then(function (response) {

              // upload icon
              if (icon) {
                let bodyFormData = new FormData();
                bodyFormData.append("file", icon);

                apiHelper
                  .updateProfileIcon(cookies.token, bodyFormData)
                  .then(function (response) {
                    //handle success
                    setOpen(true);
                    setLoading(false);
                    fetchData();
                    document.getElementById("imageFile").value = "";
                  })
                  .catch(function (response) {
                    //handle error
                    console.log("profile-icon error");
                    console.log(response);
                    setLoading(false);
                    document.getElementById("imageFile").value = "";
                  });
              } else {
                setOpen(true);
                setLoading(false);
                fetchData();
                document.getElementById("imageFile").value = "";
              }

            })
            .catch(function (error) {
              console.log("update profile error");
              console.log(error);
              setError("currentPassword", {
                type: "manual",
                message: "currentPassword.mismatcherror",
              });
              setLoading(false);
            })
            .finally(function () {
              if (isUpdatePassword) {
                //clear password field
                setValue('currentPassword', '');
                setValue('password', '');
                setValue('repassword', '');
              }
            });
      } catch (e) {
        console.log(e);
      }
    }else{
      setLoading(false);
    }
  };

  const handleImageChange = async (croppedImageUrl) => {
    console.log(croppedImageUrl);
    if (croppedImageUrl != "null") {
      setIconName('test');
      setIcon(croppedImageUrl);

      try {
        const file = croppedImageUrl;
        const image = await resizeFile(file);
        setIcon(image);
      } catch (err) {
        console.log(err);
      }
    }else {
      setIconName("");
      setIcon(null);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Box className={classes.pageContainer}>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          Updated!
        </Alert>
      </Snackbar>
      <Box className={classes.container}>
        <form onSubmit={handleSubmit(toSubmitProfileUpdate)}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant="h1">{t("editprofile")}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Avatar
                alt=""
                src={profile.iconImage}
                className={classes.propic}
                onClick={() => changeIcon.current.click()}
              />
              <ImageCrop handleImageChange={handleImageChange} />
              <Typography variant="h3" style={{ marginTop: "0", color: "#b3b3b3", marginBottom: "20px" }}>
                {t("changeiconrule")}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Controller
                name="firstName"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <InputLabel htmlFor="firstName" variant="outlined">
                      {t("firstName.label")}
                    </InputLabel>
                    <TextField
                      id="firstName"
                      variant="outlined"
                      margin="dense"
                      className={classes.textInput}
                      placeholder={t("firstName.placeholder")}
                      fullWidth
                      error={!!error}
                      helperText={error ? t(error.message) : ""}
                      disabled
                      vlaue={field.value}
                      {...field}
                    />
                  </>
                )}
              />
            </Grid>

            <Grid item xs={6}>
              <Controller
                name="lastName"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <InputLabel htmlFor="lastName" variant="outlined">
                      {t("lastName.label")}
                    </InputLabel>
                    <TextField
                      id="lastName"
                      variant="outlined"
                      margin="dense"
                      className={classes.textInput}
                      placeholder={t("lastName.placeholder")}
                      fullWidth
                      {...field}
                      error={!!error}
                      helperText={error ? t(error.message) : ""}
                      disabled
                    />
                  </>
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <InputLabel htmlFor="gender" variant="outlined">
                {t("gender")}
              </InputLabel>
              <Controller
              name="gender"
              control={control}
              render={({ field }) => (
                <ToggleButtonGroup
                  {...field}
                  id="gender"
                  value={field.value}
                  defaultValue={field.value}
                  exclusive
                  onChange={(event, newValue) => {
                    console.log(newValue)
                    field.onChange(newValue)
                  }}
                  aria-label="gender"
                  size="large"
                  style={{
                    width: "100%",
                    height: "60px",
                    color: "#000000",
                    marginTop: "7px",
                  }}
                >
                  <ToggleButton value="0" aria-label="0">
                    {t("male")}
                  </ToggleButton>
                  <ToggleButton value="1" aria-label="1">
                    {t("female")}
                  </ToggleButton>
                  <ToggleButton value="2" aria-label="2">
                    {t("others")}
                  </ToggleButton> 
                </ToggleButtonGroup>
              )}
              />
            </Grid>

            <Grid item xs={12}>
              <Controller
                name="address"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <InputLabel htmlFor="address" variant="outlined">
                      {t("address.label")}
                    </InputLabel>
                    <TextField
                      id="address"
                      variant="outlined"
                      margin="dense"
                      className={classes.textInput}
                      placeholder={t("address.placeholder")}
                      fullWidth
                      error={!!error}
                      helperText={error ? t(error.message) : ""}
                      {...field}
                    />
                  </>
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Controller
                name="contactNumber"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <InputLabel htmlFor="contactNumber" variant="outlined">
                      {t("contactNumber.label")}
                    </InputLabel>
                    <TextField
                      id="contactNumber"
                      variant="outlined"
                      margin="dense"
                      className={classes.textInput}
                      placeholder={t("contactNumber.placeholder")}
                      fullWidth
                      error={!!error}
                      helperText={error ? t(error.message) : ""}
                      disabled
                      {...field}
                    />
                  </>
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Controller
                name="email"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <InputLabel htmlFor="email" variant="outlined">
                      {t("email.label")}
                    </InputLabel>
                    <TextField
                      id="email"
                      variant="outlined"
                      margin="dense"
                      className={classes.textInput}
                      placeholder={t("email.placeholder")}
                      fullWidth
                      error={!!error}
                      helperText={error ? t(error.message) : ""}
                      {...field}
                    />
                  </>
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Controller
                name="dob"
                control={control}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <>
                    <InputLabel htmlFor="dob" variant="outlined">
                      {t("dob.label")}
                    </InputLabel>

                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        fullWidth
                        variant="outlined"
                        inputVariant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position={"end"}>
                              <CalendarTodayIcon />
                            </InputAdornment>
                          ),
                        }}
                        margin="dense"
                        openTo="year"
                        views={["year", "month"]}
                        placeholder={t("dob.placeholder")}
                        format="MM/yyyy"
                        onChange={onChange}
                        value={value || ''}
                        disabled={!canUpdateDob}
                      />
                    </MuiPickersUtilsProvider>
                  </>
                )}
              />
            </Grid>

          </Grid>

          <Grid container spacing={1}>
          <Grid item xs={12}>
              <Controller
                name="currentPassword"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <InputLabel htmlFor="currentPassword" variant="outlined">
                      {t('currentPassword.label')}
                    </InputLabel>
                    <TextField
                      id="currentPassword"
                      variant="outlined"
                      type="password"
                      margin="dense"
                      className={classes.textInput}
                      fullWidth
                      error={!!error}
                      helperText={error ? t(error.message) : ""}
                      {...field}
                    />
                  </>
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Controller
                name="password"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <InputLabel htmlFor="password" variant="outlined">
                      {t('password.label')}
                    </InputLabel>
                    <TextField
                      id="password"
                      variant="outlined"
                      type="password"
                      margin="dense"
                      className={classes.textInput}
                      fullWidth
                      error={!!error}
                      helperText={error ? t(error.message) : ""}
                      {...field}
                    />
                  </>
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Controller
                name="repassword"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <InputLabel htmlFor="repassword" variant="outlined">
                      {t('repassword.label')}
                    </InputLabel>
                    <TextField
                      id="repassword"
                      variant="outlined"
                      type="password"
                      margin="dense"
                      className={classes.textInput}
                      fullWidth
                      error={!!error}
                      helperText={error ? t(error.message) : ""}
                      {...field}
                    />
                  </>
                )}
              />
            </Grid>

          </Grid>

          <div className={classes.wrapper}>
            <Button
              type="submit"
              className={classes.btn}
              variant="contained"
              fullWidth
              disabled={loading}
            >
              {t("updateprofile")}
            </Button>
            {loading && <LinearProgress/>}
          </div>
        </form>
      </Box>
    </Box>
  );
}

export default ProfileEditPage;
